/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */

class ConsoleAdapter {
  debug(id, message, optionalInfo) {
    this._log('debug', message, id, optionalInfo);
  }

  info(id, message, optionalInfo) {
    this._log('info', message, id, optionalInfo);
  }

  warn(id, message, optionalInfo) {
    this._log('warn', message, id, optionalInfo);
  }

  error(id, message, optionalInfo) {
    this._log('error', message, id, optionalInfo);
  }

  _log(level, message, id, optionalInfo = {}) {
    const { datasource, ...otherData } = optionalInfo;
    // eslint-disable-next-line no-console
    console[level](id, message, datasource, otherData);
  }
}

const singletonInstance = new ConsoleAdapter();

export default Object.freeze(singletonInstance);
